import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=dcee2be4"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=dcee2be4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports